import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import Product from "../products/Card";
import { Link } from "react-router-dom";

function SearchCanvas({ isOpen, searchText, setSearchText }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);

  // const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!searchText) {
      setProducts([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchProducts(1, searchText);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, searchText) => {
    setLoading(true);

    try {
      if (searchText) {
        const res = await productAPI.listing({
          page: pageNum,
          limit: 6,
          keyword: searchText,
        });

        if (res.code === 200) {
          const { products, base_url } = res.data;

          const items = products;

          setProducts((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        }
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !searchText) return null;

  return (
    <div className="search-dropdown">
      {loading && <p className="p-2">Loading...</p>}

      {!loading && products.length === 0 && (
        <p className="p-2">No products found</p>
      )}

      {searchText && (
        <>
          {loading && <p>Loading...</p>}

          {products.map((product) => {
            const image = product?.thumbnail || product?.images?.[0];

            const price = product?.variants?.[0]?.price || product?.price;

            return (
              <Link
                to={`/shop/${product.slug}`}
                className="search-item text-decoration-none"
                key={product._id}
              >
                <img src={image} className="search-img" alt={product.title} />
                <div>
                  <p className="search-title">{product.title}</p>
                  <p className="search-price">₹{price}</p>
                </div>
              </Link>
            );
          })}
        </>
      )}
    </div>
  );
}

export default SearchCanvas;
